// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__PC5cn","clickable":"style_clickable__6RO2V","cardWrapper":"style_cardWrapper__wC99X","active":"style_active__otXV9","headers":"style_headers__4Yv-X"};